var $ = require("jquery");
var breakpoint = require('./app-breakpoints');
var _gridSize = breakpoint().match(/(\d+)/g);
var _winSize = $(window).width();
var _gridLabel = breakpoint().replace(/\d+/g, '').replace(" ", "").replace(/\"/g, "");


require("../../bower_components/modal-video/js/jquery-modal-video.min");

//require("./wow");

const {WOW} = require('./wow');

var wow = new WOW({
  boxClass: 'wow', // default
  animateClass: 'animated', // default
  offset: 50,
  mobile: true, // default
  live: false,
  callback: function (box) {
    $('body').addClass('loaded');
  },
});

wow.init();
const {slick} = require("../../bower_components/slick-carousel/slick/slick");


$(function () {

  require('./app-map');

  // Init homepage slider
  $(".c-slider .items").slick({
    autoplay: true,
    responsive: false,
    fade: true,
    dots: false,
    autoplaySpeed: 4000,
    arrows: true,
    appendArrows: $(".sliderBottomContainer .arrowWrapper"),
    customPaging: function (slider, i) {
      var slidernav = $(slider.$slides[i]).data('slidernav');
      return '<a>' + slidernav + '</a>';
    }
  });

  // Breadcrumbs - remove duplicated items
  if ($("body").is(".single-produit")) {
    $(".lafond-breadcrumbs span[property='itemListElement']").each(function(index, el) {
      var $previousEl = $(el).prevAll("span[property='itemListElement']").eq(0);

      if ($previousEl.length) {
        // Check if current element is equal to previous element
        // Remove previous element to prevent redundancy
        if ($(el).text() === $previousEl.text()) {
          $previousEl.next("span:not([property='itemListElement'])").remove();
          $previousEl.remove();
        }
      }
    });
  }

  // Article - shortcode slider
  $(".content-gallery .content-gallery-inner").each(function () {
    var slider = $(this);

    slider.slick({
      responsive: false,
      fade: true,
      dots: false,
      arrows: true,
      prevArrow: slider.parent().find(".content-gallery-navigation .slick-prev"),
      nextArrow: slider.parent().find(".content-gallery-navigation .slick-next")
    });
  });

  // Article - sharing
  $("#post-content .post-share a").on("click", function (e) {
    var $el = $(e.currentTarget);
    var href = $el.attr("href");

    var leftPosition, topPosition;
    leftPosition = (window.screen.width / 2) - ((600 / 2) + 10);
    topPosition = (window.screen.height / 2) - ((600 / 2) + 50);

    if (!$("html").is(".mobile")) {
      e.preventDefault();
      window.open(href, 'ShareWindow', 'width=600, height=600, left=' + leftPosition + ', top=' + topPosition + ', screenX=' + leftPosition + ', screenY=' + topPosition);
    } else {
      // Nothing, open the link instead
    }
  });

  // TrackDesign Vimeo event
  $((function () {
    var iframe = $("#trackdesign-video");

    if (iframe.length) {
      var player = new Vimeo.Player(iframe[0]);

      player.ready().then(function () {
        $("#trakdesign-play").on("click", function (e) {
          player.play();

          $(e.currentTarget).siblings("#trackdesign-thumbnail").fadeOut('400', function() {
            $(this).remove();
          });
          $(e.currentTarget).fadeOut('400', function() {
            $(this).remove();
          });
        });
      });
    }
  }));

  // Init slide count
  if ($(".c-slider .items").is(".slick-initialized")) {
    $(".homeSlider .sliderBottomContainer .sliderCounter-total").text($(".c-slider .items")[0].slick.slideCount);
  }
  $(".c-slider .items").on('init reInit afterChange', function (e, slick, currentSlide, nextSlide) {
    var i = (currentSlide ? currentSlide : 0) + 1;
    $(".homeSlider .sliderBottomContainer .sliderCounter-current").text(i);
    $(".homeSlider .sliderBottomContainer .sliderCounter-total").text(slick.slideCount);
  });

  $('.c-block__home_produit .group-right .items').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 300000,
    dots: false,
    arrows: true,
    appendArrows: $(".c-block__home_produit .arrowWrapper"),
    responsive: [
      {
        breakpoint: 1500,
        settings: {slidesToShow: 2, slidesToScroll: 1}
      },
      {
        breakpoint: 991,
        settings: {slidesToShow: 1, slidesToScroll: 1}
      }]
  });
  // Init slide count
  if ($(".c-block__home_produit .group-right .items").is(".slick-initialized")) {
    $(".c-block__home_produit .group-left .sliderCounter-total").text($(".c-block__home_produit .group-right .items")[0].slick.slideCount);
  }
  $(".c-block__home_produit .group-right .items").on('init reInit afterChange', function (e, slick, currentSlide, nextSlide) {
    var i = (currentSlide ? currentSlide : 0) + 1;
    $(".c-block__home_produit .group-left .sliderCounter-current").text(i);
    $(".c-block__home_produit .group-left .sliderCounter-total").text(slick.slideCount);
  });


  if ($(".c-footercta").hasClass("c-footercta_testimonial")) {
    $('.c-footercta .items').slick({
      infinite: true,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      dots: false,
      arrows: true,
      appendArrows: $(".c-footercta .arrowWrapper")
    });
  }

  $('.c-block__wrapper .gallery .items').slick({
    autoplay: true,
    responsive: false,
    fade: true,
    dots: false,
    autoplaySpeed: 3000,
    arrows: true,
    appendArrows: $(".c-block__wrapper .gallery .arrowWrapper"),
  });

  // Tablepress plugin tables
  // Make the table responsive
  $.each($("table.tablepress"), function (index, el) {
    $.each($(el).find("th"), function (header_index, header_el) {
      var columnClass = header_el.className.match(/column-\d+/);

      if (columnClass) {
        $(el).find("td." + columnClass[0]).attr("data-th", $(header_el).text());
      }
    });
  });

  $(window).ready(function () {
    if ($(".c-block__wrapper .media").hasClass("has_video")) {
      $(".js-video-button").modalVideo({
        youtube: {
          autoplay: 1,
          controls: 0,
          nocookie: true
        }
      });
    }
    //$( ".height_minimized" ).first().css( "padding-top", "100px" );

    // if ($(".c-page-content").hasClass("page-infolettre")) {
    // 	$('.c-newsletter-form input[type=email]').val($('.c-newsletter-form').attr('data-email'));
    // }

    //$('.c-block-_std').last().css('padding-bottom','80px');
  });

  $(document).on('click', '.nav-trigger', function (e) {

    $('.nav-trigger').toggleClass('is-active');
    //$('#menu-mobile').slideToggle();
    $('body').toggleClass('menu-open');

    return false;
  });
  $(document).on('click', '.menu-open .l-main', function (e) {
    $('.nav-trigger').toggleClass('is-active');
    $('body').toggleClass('menu-open');


    return false;
  });


  // $(window).scroll(function() {
  // 	if(_gridLabel != "smartphone") {

  // 	}
  // });


  $('.c-block__faconnage .items').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 300000,
    dots: false,
    arrows: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1679,
        settings: {slidesToShow: 2, slidesToScroll: 1, variableWidth: false}
      }, {
        breakpoint: 768,
        settings: {slidesToShow: 1, slidesToScroll: 1, variableWidth: false}
      }
    ]
    //appendArrows: $(".c-block__faconnage .arrowWrapper"),
  });

  // On after slide change
  $('.c-block__faconnage .items').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    //console.log(nextSlide);
    $(this).parent().find('.descriptionBox').text($(this).parent().find('.slick-slide[data-slick-index=' + nextSlide + ']').find('.item').attr('data-desc'));
  });

  $('.c-block__faconnage .items').on('breakpoint', function (event, slick, currentSlide, nextSlide) {
    $(this).parent().find(".slick-prev").appendTo($(this).parent().find('.arrowWrapper'));
    $(this).parent().find(".slick-next").appendTo($(this).parent().find('.arrowWrapper'));
  });

  $('.c-block__faconnage .items').trigger('breakpoint');

  $(window).on('load', function () {
    var width_to_add = $(window).width() / 12;
    $('.c-block__faconnage .slick-slide').css('padding-right', width_to_add);
    $('.c-block__faconnage .items .item').attr('style', 'width:calc(100% + ' + width_to_add + 'px) !important;');

    // $('.c-block__faconnage').each(function(index){
    // 	$(this).find(".slick-prev").appendTo( $(this).find('.arrowWrapper'));
    // 	$(this).find(".slick-next").appendTo( $(this).find('.arrowWrapper'));
    // });

    $('.c-block__faconnage .arrowWrapper .slick-next').trigger('click');
  });

  $(window).resize(function () {
    _gridSize = breakpoint().match(/(\d+)/g);
    _winSize = $(window).width();
    _margin = (_winSize - _gridSize) / 2;

    _gridLabel = breakpoint().replace(/\d+/g, '').replace(' ', '');

    if (_gridLabel == "smartphone") {

    }

  }).resize();
});

// Produit numerique & Modification 2023
(function ($) {

  $('document').ready(function () {

    // Main menu, toggle submenus
    $("#main-menu .menu-mobile > li.menu-item-has-children > a").off("click").on("click", function (e) {
      var $el = $(e.currentTarget);
      // e.preventDefault();

      if ($el.parent(".menu-item").is(".shown")) {
        // Go to parent URL
        // $el.siblings(".sub-menu").stop().slideUp();
        // $el.parent(".menu-item-has-children").removeClass("shown");
      } else {
        e.preventDefault();
        $("#main-menu .menu-mobile li.menu-item-has-children").removeClass("shown");
        $("#main-menu .menu-mobile .sub-menu").stop().slideUp();

        $el.parent(".menu-item-has-children").addClass("shown");
        $el.siblings(".sub-menu").stop().slideDown();
      }
    });

    //-- Digital product submenu
    var stickyNavTop = 0;
    var scrollSetTimeout = false;

    if ($('body').hasClass('single-produit-numerique')) {
      stickyNavTop = $('section.fabrication .etapesMenu_wrapper').offset().top - 76;

      // Init step menu swiper
      var $stepMenu = $(".etapesMenu_wrapper");
      var stepMenuSwiper = new Swiper($stepMenu.find(".swiper")[0], {
        slidesPerView: "auto",
        grabCursor: true,
        slideToClickedSlide: true,

        navigation: {
          prevEl: $stepMenu.find('.swiper-button-prev')[0],
          nextEl: $stepMenu.find('.swiper-button-next')[0],
        },
      });

      $stepMenu.find("a[href]").on("click", function (e) {
        e.preventDefault();
        var anchor = $(e.currentTarget).attr("href");
        var y = $(anchor).offset().top - $(".etapesMenu_wrapper").outerHeight() - $("header").outerHeight() - 20;

        $('html, body').animate({
          scrollTop: y
        }, 500);
      });

      // Update the offset position of the menu on resize
      $(window).on("resize", function () {
        stickyNavTop = $('section.fabrication .etapesMenu_wrapper').offset().top - 76;
      });
    }

    var stickyMainNav = function () {
      //-- Main header
      if ($(this).scrollTop() > 50) {
        $('body, header').addClass("small_header");
      } else {
        $('body, header').removeClass("small_header");
      }
    };

    var stickyProductNav = function () {
      //-- Digital product submenu
      if ($('body').hasClass('single-produit-numerique')) {

        if ($('section.fabrication').get(0).getBoundingClientRect().bottom < ($("header").outerHeight() + $(".etapesMenu_wrapper").outerHeight())) {
          $('body, .fabrication > .introduction, .etapesMenu_wrapper').addClass("sticky_bottom");
        } else if ($(this).scrollTop() > stickyNavTop) {
          $('body, .fabrication > .introduction, .etapesMenu_wrapper').addClass('sticky_etapes').removeClass("sticky_bottom");
        } else {
          $('body, .fabrication > .introduction, .etapesMenu_wrapper').removeClass('sticky_etapes');
        }

        // Highlight menu item on scroll
        $.each($(".etapesMenu_wrapper a[href*='#']"), function (index, el) {
          var href = $(el).attr("href");
          var $element = $(href);

          if ($element.length) {
            if ($element.get(0).getBoundingClientRect().y <= (76 + $(".etapesMenu_wrapper").outerHeight()) + 21) {
              $(".etapesMenu_wrapper a[href*='#']").removeClass("active");
              $(el).addClass("active");

              if (scrollSetTimeout) {
                clearTimeout(scrollSetTimeout);
              }
              scrollSetTimeout = setTimeout(function () {
                stepMenuSwiper.slideTo(index);
              }, 50);
            } else {
              $(el).removeClass("active");
            }
          }
        });
      }
    };

    stickyMainNav();
    stickyProductNav();

    //-- Sticky headers
    $(window).scroll(function () {
      stickyMainNav();
      stickyProductNav();
    });
  });
})($);
